import { NOTIFICATIONS_FLOATING_COMPONENT, NOTIFICATIONS_SIDEBAR_COMPONENT, NOTIFICATIONS_TEASE_COMPONENT } from 'navigation-components/config';
import { useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback } from 'react';
import { DELIVERY_METHOD_NAMES } from '../../constants';
import isNotificationsDisable from '../../utils/isNotificationsDisable';
export function useLoadNotificationsComponent() {
  const {
    toggle: toggleFloating
  } = useToggleComponent(NOTIFICATIONS_FLOATING_COMPONENT);
  const {
    toggle: toggleSidebar
  } = useToggleComponent(NOTIFICATIONS_SIDEBAR_COMPONENT);
  const {
    toggle: toggleTease
  } = useToggleComponent(NOTIFICATIONS_TEASE_COMPONENT);

  /**
   * React to a realtime event and load the associated nav component if required
   */
  const toggleComponentOn = useCallback((method, isPrimary) => {
    if (isNotificationsDisable()) {
      return;
    }
    switch (method) {
      case DELIVERY_METHOD_NAMES.FLOATING:
        // Floating will only show on the primary tab so no need to load floating
        // on the non primary tabs at this time
        if (isPrimary) {
          toggleFloating(true);
        }
        break;
      case DELIVERY_METHOD_NAMES.SIDEBAR:
        // We must load sidebar for all tabs as it is now up to the nav components
        // to manage cross tab synchronization of the count
        toggleSidebar(true);
        break;
      case DELIVERY_METHOD_NAMES.BROWSER:
      case DELIVERY_METHOD_NAMES.TEASE:
        toggleTease(true);
        break;
      default:
        break;
    }
  }, [toggleFloating, toggleSidebar, toggleTease]);
  return toggleComponentOn;
}